module.exports = __webpack_public_path__ + "static/media/final.910d2eb6.JPG";